import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { Conductor, ConductorCollaborator, ConductorCollaboratorFilter } from '../models/conductors';
import { Paged } from '../models/paged';
import { CreateCardholder, UpdateCardholder } from '../models/cardholder';

@Injectable({
    providedIn: 'root'
})
export class CardholderService {

    private URL = environment.GATEWAY + 'collaborator';

    constructor(
        private http: HttpClient
    ) { }

    getCardholders(assignorGuid: string, page: number, limit: number, costCenter?: number): Observable<ResponseBase<Paged<any>>> {

        let params = new HttpParams();
        params = params.append('assignorGuid', assignorGuid);
        params = params.append('offset', ((page-1)*limit).toString());
        params = params.append('limit', limit.toString());
        if (costCenter) params = params.append('costCenter', costCenter.toString());

        return this.http.get<ResponseBase<Paged<Conductor>>>(`${this.URL}/cardholder`, { params });
    }

    getCardholder(collaboratorId: number): Observable<ResponseBase<any>> {
        return this.http.get<ResponseBase<any>>(`${this.URL}/collaborator/${collaboratorId}`);
    }

    createCardholder(createCardholder: CreateCardholder): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/cardholder`, createCardholder);
    }

    updateCardholder(updateCardholder: UpdateCardholder): Observable<ResponseBase<any>> {
        return this.http.put<ResponseBase<any>>(`${this.URL}/cardholder`, updateCardholder);
    }

    deleteCardholder(cardholderGuid: string): Observable<ResponseBase<any>> {
        return this.http.delete<ResponseBase<any>>(`${this.URL}/${cardholderGuid}`);
    }
}